export default __webpack_public_path__ + "assets/images/c97bbd69822b87f7866ca68d373ab304.svg";